import React from 'react'
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import api from '../../../api/api';


const About = () => {
  const { register, handleSubmit, unregister, setValue } = useForm();
  const handleSub = (data) => {
    const image = data.image[0]

    const formData = new FormData();
    formData.append("title",data.title);
    formData.append("image",image);
    formData.append("description",data.description);
     
    api
    .post("/info/about-us/descriptions/",formData)
    .then((response)=>{
      toast.success("Data Registered Successfully.");

    })
    .catch((error) => {
      toast.error("Registration Failed");
    });
  }

  return (
    <div className=' px-10'>
        
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
       Add About Section
      </h1>
<form className='mt-5'>
      <div className='border-2 grid  md:grid-cols-2 text-xl  border-primary-red '>
<div className='md:border-r border-b border-primary-red p-2' >
    <label htmlFor="" className='text-primary-blue'>Title</label>
    <input type="text" className='outline-none w-40 md:w-auto pl-2  '
                {...register("title", { required: false })}
                />
</div>

<div className='border-b text-primary-blue border-primary-red p-2 '>
    <label htmlFor="">Image</label>
    <input type="file"
    className='file:text-white w-40 md:w-auto  file:bg-primary-red file:border-0 file:rounded-2xl pl-3'
                {...register("image", { required: false })}
                />
</div>
<div className='md:border-r flex md:flex-row flex-col gap-3 border-primary-red text-primary-blue p-2'>
    <p htmlFor="">Description</p>
    <textarea type="text" 
    className='border-primary-blue  outline-none text-sm pl-1 md:w-72 border'
                {...register("description", { required: false })}
                />
</div>

      </div>
      <button
             onClick={handleSubmit(handleSub)}
      className="bg-primary-red p-2 float-right rounded-2xl text-white m-auto mt-5"
      > submit</button>
  </form>
    </div>
  )
}

export default About